 import ClinicPricing from "./ClinicPricing";
import StepHeader from "../ServiceStepHeader";
import { useSearchParams } from "react-router-dom";
import GeneralDetailsFormComponent from "./GeneralDetailsFormComponent";

const ServiceAddComponent = () => {
  const [params] = useSearchParams();
  const pageStep = params.get("page_step");
  let step = 2;
  if (pageStep === "general_details") step = 2;
  if (pageStep === "clinic_pricing") step = 3;

  return (
    <>
      <div className="px-4 py-4">
        <StepHeader step={step} />
        {step === 2 && (
          <div>
            <GeneralDetailsFormComponent />
          </div>
        )}
        {step === 3 && (
          <div>
            <ClinicPricing />
          </div>
        )}
      </div>
    </>
  );
};

export default ServiceAddComponent;
